import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Elements, StripeProvider } from "react-stripe-elements";
import theme from "@muchbetteradventures/mui-theme/theme";

import GiftCardForm from "./components/GiftCardForm";

// eslint-disable-next-line react/prop-types
const App = ({ stripePublicKey }) => (
  <MuiThemeProvider theme={theme}>
    <StripeProvider apiKey={stripePublicKey}>
      <Elements>
        <GiftCardForm />
      </Elements>
    </StripeProvider>
  </MuiThemeProvider>
);

export default App;
